let statuses = [
    {title: 'Pending', value: 'pending'},
    // { title: 'Ontheway', value: 'ontheway' },
    {title: 'Accepted', value: 'accepted'},
    {title: 'Rejected', value: 'rejected'},
    // { title: 'Cancelled', value: 'cancelled' },
    // { title: 'Delivered', value: 'delivered' }
];
export default statuses;
